export default __webpack_public_path__ + "static/media/puppyFemaleOrange.a51b3648.jpg";